module.exports = __webpack_public_path__ + "img/linux.603d2fd4.svg";